import styled from 'styled-components';
import { spacing, borderRadius } from '@config/spacing';
import { typography } from '@config/typography';
import { colors } from '@config/seafoam_colors';

export const BlogsContainer = styled.div`
  padding: ${spacing['4xl']} ${spacing.xl};
  max-width: 1000px;
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  font-family: ${typography.fontFamily.heading};
  font-size: ${typography.fontSize['4xl']};
  font-weight: ${typography.fontWeights.medium};
  color: ${colors.text};
  margin: 0 0 ${spacing.md} 0;
`;

export const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: ${spacing.xl};
`;

export const BlogCard = styled.a`
  display: block;
  text-decoration: none;
  border-radius: ${borderRadius.lg};
  overflow: hidden;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(148, 163, 184, 0.25);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }
`;

export const BlogCardImage = styled.div<{ $src: string }>`
  width: 100%;
  height: 200px;
  background-image: url(${({ $src }) => $src});
  background-size: cover;
  background-position: center;
`;

export const BlogCardBody = styled.div`
  padding: ${spacing.xl};
`;

export const BlogCardTitle = styled.h2`
  font-family: ${typography.fontFamily.heading};
  font-size: ${typography.fontSize.xl};
  font-weight: ${typography.fontWeights.semibold};
  color: ${colors.text};
  margin: 0 0 ${spacing.sm} 0;
  line-height: ${typography.lineHeight.tight};
`;

